import { __extends } from "tslib";
import { Filter3DTaskBase } from './Filter3DTaskBase';
import { ContextGLProgramType } from '../../base/ContextGLProgramType';
var Filter3DVBlurTask = /** @class */ (function (_super) {
    __extends(Filter3DVBlurTask, _super);
    /**
     *
     * @param amount
     * @param stepSize The distance between samples. Set to -1 to autodetect with acceptable quality.
     */
    function Filter3DVBlurTask(amount, stepSize) {
        if (stepSize === void 0) { stepSize = -1; }
        var _this = _super.call(this) || this;
        _this._stepSize = 1;
        _this._amount = amount;
        _this._data = new Float32Array([0, 0, 0, 1]);
        _this.stepSize = stepSize;
        return _this;
    }
    Object.defineProperty(Filter3DVBlurTask.prototype, "amount", {
        get: function () {
            return this._amount;
        },
        set: function (value) {
            if (this._amount == value)
                return;
            this._amount = value;
            this.invalidateProgram();
            this.updateBlurData();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Filter3DVBlurTask.prototype, "stepSize", {
        get: function () {
            return this._stepSize;
        },
        set: function (value) {
            if (this._stepSize == value)
                return;
            this._stepSize = value;
            this.calculateStepSize();
            this.invalidateProgram();
            this.updateBlurData();
        },
        enumerable: true,
        configurable: true
    });
    Filter3DVBlurTask.prototype.getFragmentCode = function () {
        var temp1 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp1, 1);
        var temp2 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp2, 1);
        var temp3 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp3, 1);
        var inputTexture = this._registerCache.getFreeTextureReg();
        this._inputTextureIndex = inputTexture.index;
        var blur = this._registerCache.getFreeFragmentConstant();
        this._blurIndex = blur.index * 4;
        var code;
        var numSamples = 1;
        code = 'mov ' + temp1 + ', ' + this._uvVarying + '\n' +
            'sub ' + temp1 + '.y, ' + this._uvVarying + '.y, ' + blur + '.x\n';
        code += 'tex ' + temp2 + ', ' + temp1 + ', ' + inputTexture + ' <2d,linear,clamp>\n';
        for (var x = this._realStepSize; x <= this._amount; x += this._realStepSize) {
            code += 'add ' + temp1 + '.y, ' + temp1 + '.y, ' + blur + '.y\n';
            code += 'tex ' + temp3 + ', ' + temp1 + ', ' + inputTexture + ' <2d,linear,clamp>\n' +
                'add ' + temp2 + ', ' + temp2 + ', ' + temp3 + '\n';
            ++numSamples;
        }
        code += 'mul oc, ' + temp2 + ', ' + blur + '.z\n';
        this._data[2] = 1 / numSamples;
        return code;
    };
    Filter3DVBlurTask.prototype.activate = function (stage, projection, depthTexture) {
        stage.context.setProgramConstantsFromArray(ContextGLProgramType.FRAGMENT, this._data);
    };
    Filter3DVBlurTask.prototype.updateTextures = function (stage) {
        _super.prototype.updateTextures.call(this, stage);
        this.updateBlurData();
    };
    Filter3DVBlurTask.prototype.updateBlurData = function () {
        // todo: must be normalized using view size ratio instead of texture
        var invH = 1 / this._textureHeight;
        this._data[0] = this._amount * .5 * invH;
        this._data[1] = this._realStepSize * invH;
    };
    Filter3DVBlurTask.prototype.calculateStepSize = function () {
        this._realStepSize = this._stepSize > 0 ? this._stepSize : this._amount > Filter3DVBlurTask.MAX_AUTO_SAMPLES ? this._amount / Filter3DVBlurTask.MAX_AUTO_SAMPLES : 1;
    };
    Filter3DVBlurTask.MAX_AUTO_SAMPLES = 15;
    return Filter3DVBlurTask;
}(Filter3DTaskBase));
export { Filter3DVBlurTask };
